import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevron2DownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron2_down_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M328.832 225.835a42.667 42.667 0 0 0-60.33 60.33L481.834 499.5a42.667 42.667 0 0 0 60.33 0L755.5 286.165a42.667 42.667 0 0 0-60.331-60.33L512 409.003 328.832 225.835zm0 298.666a42.667 42.667 0 0 0-60.33 60.331l213.333 213.333a42.667 42.667 0 0 0 60.33 0L755.5 584.832a42.667 42.667 0 0 0-60.331-60.33L512 707.668 328.832 524.501z"
    />
  </svg>
);
export default SvgArrowchevron2DownIcon;
